import React, { useEffect, useRef, useState } from "react";
import "./custom-doc-viewer.css";
import ModalWrapper from "../Modal/ModalWrapper";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import handleDownloadDocx from "../../utils/helpers/handleDownloadDocx";

const CustomDocViewer: React.FunctionComponent<{ url: string; uploadedFile: any; onClose: () => void }> = ({ url = "", uploadedFile = null, onClose }) => {
  const docViewerModalRef = useRef<any>(null);
  const [showModal, setShowModal] = useState(false);
  const [fileType, setFileType] = useState<"docx" | "pdf" | "unknown">("unknown");

  useEffect(() => {
    setShowModal(true);
  }, []);

  useEffect(() => {
    if (fileType === "docx" && url) {
      handleDownloadDocx(url);
    }
  }, [fileType]);

  useEffect(() => {
    if (docViewerModalRef.current) {
      const modal = docViewerModalRef.current;
      modal.toggleModalWrapper(showModal);
    }
  }, [showModal]);

  useEffect(() => {
    if (url) {
      determineFileType(url);
    } else if (uploadedFile) {
      if (uploadedFile.type === "application/pdf") {
        setFileType("pdf");
      } else if (uploadedFile.type === "application/msword" || uploadedFile.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
        setFileType("docx");
      }
    }
  }, [url, uploadedFile]);

  const closeModal = () => {
    setShowModal(false);
    onClose();
  };

  const determineFileType = (fileUrl: string) => {
    if (fileUrl.split("?")[0].split(".").reverse()[0] === "pdf") {
      setFileType("pdf");
    } else if (fileUrl.split("?")[0].split(".").reverse()[0] === "doc" || fileUrl.split("?")[0].split(".").reverse()[0] === "docx") {
      setFileType("docx");
    } else {
      setFileType("unknown");
    }
  };

  const renderViewer = () => {
    if (fileType === "pdf") {
      if (url) {
        return (
          <DocViewer
            config={{ pdfVerticalScrollByDefault: true }}
            documents={[{ uri: url.replace("https://kmf-central.s3.ap-south-1.amazonaws.com", "https://uatapi-mfcentral.kfintech.com") }]}
            pluginRenderers={DocViewerRenderers}
            activeDocument={{ uri: url.replace("https://kmf-central.s3.ap-south-1.amazonaws.com", "https://uatapi-mfcentral.kfintech.com") }}
            prefetchMethod="GET"
            requestHeaders={{ "Content-Disposition": "attachment" }}
          />
        );
      } else {
        return <iframe src={URL.createObjectURL(uploadedFile)} width="100%" height="500px" />;
      }
    } else if (fileType === "docx") {
      return;
    } else {
      return <div>Unsupported file type</div>;
    }
  };

  return (
    <div className="legal-modal-container">
      <ModalWrapper ref={docViewerModalRef} title={"Document Viewer"} className="legal-doc-viewer-modal" callback={closeModal}>
        <div className="mf-doc-viewer-body">{renderViewer()}</div>
      </ModalWrapper>
    </div>
  );
};

export default CustomDocViewer;
